import { Route } from "react-router";

import { TransformationReferencesPage } from "./TransformationReferencesPage";

export const useTransformationRouter = () => {
    return <Route path="transformations" element={<TransformationReferencesPage />} />;
};
